export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&=]*)\/?\S*/;

export const isValueURL = (val: string | undefined) => !!val?.match(URL_REGEX);
